import { render, staticRenderFns } from "./KarmaProgramList.vue?vue&type=template&id=2bbc6768&scoped=true&"
import script from "./KarmaProgramList.vue?vue&type=script&lang=js&"
export * from "./KarmaProgramList.vue?vue&type=script&lang=js&"
import style0 from "./KarmaProgramList.vue?vue&type=style&index=0&id=2bbc6768&lang=scss&scoped=true&"
import style1 from "./KarmaProgramList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbc6768",
  null
  
)

export default component.exports